import styled from 'styled-components';

export const FeaturedRewardsContainer = styled.div`
  margin: 1rem 0;
`;

export const Title = styled.h2`
  color: ${Styles.color.contrastBackground};
  font-family: ${Styles.fontFamily.base};
  margin: 0.5rem 1.5rem;
`;
